<template>
  <div
    class="table-body"
    ref="tableBody"
    :style="tableBodyWidth"
  >
    <div
      class="table"
      ref="table"
    >
      <div class="tbody">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { getApp } from '@/assets/js/mixins/common/GetApp'

export default {
  name: 'tbl-body',

  inject: {
    tblConfig: {}
  },

  mixins: [ getApp ],

  watch: {
    'getApp.drawer': function () {
      this.getTableBodyWidth()
    },

    async '$route' (to, from) {
      this.getTableBodyWidth()
    }
  },

  computed: {
    tableBodyWidth () {
      let width = this.tblConfig.body_w

      return {
        width: width + 'px'
      }
    }
  },

  mounted () {
    if (!this.loading) {
      this.getTableBodyWidth()
    }
  },

  methods: {
    getTableBodyWidth () {
      this.width = this.$refs.table.clientWidth
      this.tblConfig.body_w = this.$refs.table.clientWidth
      this.tblConfig.head_w = this.$refs.table.clientWidth

      this.$nextTick(() => {
        if (!this.tblConfig.body_w) {
          this.$refs.tableBody.removeAttribute('style')
        }
      })
    }
  }
}
</script>
